import React from "react";
import FixedWidthSwitchComponent from "../../components/FixedWidthSwitchComponent";
import { faEllipsisV, faCheck } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card } from "react-bootstrap";
import { Droppable, Draggable, DragDropContext } from "react-beautiful-dnd";

const AddHierarchy = (props) => {
  const { fields, values, isEdit, isSave, setValues } = props;
  const approvalHierarchy = values["approvalHierarchy"];
  const handleOnDragEnd = (props) => {
    if (!props.destination) return;
    let list = approvalHierarchy;
    let [final] = list.splice(props.source.index, 1);
    list.splice(props.destination.index, 0, final);
    let x = list.map((item, ind) => {
      return { ...item, order: ind + 1 };
    });
    setValues({
      ...values,
      approvalHierarchy: x,
    });
  };

  const getName = (x) => {
    let name;
    switch (x) {
      case 2:
        name = "Sponsor";
        break;
      case 1:
        name = "TPA/Provider";
        break;
    }
    return name;
  };

  const setKeyFieldCheck = (itemIndex) => {
    let x = approvalHierarchy.map((itm, i) => {
      if (i == itemIndex) return (itm = { ...itm, approval: !itm.approval });
      else return itm;
    });

    // let val = !approvalHierarchy[itemIndex][fields.approval];
    // approvalHierarchy[itemIndex][fields.approval] = val;
    setValues({
      ...values,
      approvalHierarchy: x,
    });
  };

  return (
    <div>
      <p className="plan-sub-heading">Approval Hierarchy</p>
      <div>
        <div className="HierarchycardHeading">
          <div className="col-1">Order</div>
          <div className="col-2" style={{ marginLeft: "35%" }}>
            UserRole
          </div>
          <div className="col-1" style={{ marginLeft: "auto" }}>
            Approval
          </div>
        </div>

        <DragDropContext
          onDragEnd={handleOnDragEnd}
          onDragStart={isEdit && !isSave}
        >
          <Droppable droppableId="hierarchy">
            {(provided) => (
              <ul {...provided.droppableProps} ref={provided.innerRef}>
                {approvalHierarchy.map((item, index) => {
                  return (
                    <Draggable
                      key={item.userRole}
                      draggableId={getName(item.userRole)}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          ref={provided.innerRef}
                        >
                          <div className="d-flex">
                            <div style={{ width: "20px" }} className="mt-3">
                              {index + 1}
                            </div>
                            <Card className="HierarchycardCss ml-5">
                              <div className="ellipsis">
                                <FontAwesomeIcon
                                  icon={faEllipsisV}
                                  size="2x"
                                  color="#828282"
                                />
                                <FontAwesomeIcon
                                  icon={faEllipsisV}
                                  size="2x"
                                  color="#828282"
                                />
                              </div>
                              <div className="userRole">
                                {getName(item.userRole)}
                              </div>
                              <div className="HierarchyApproval">
                                <FixedWidthSwitchComponent
                                  checked={item[fields.approval]}
                                  setChecked={() =>
                                    !isEdit && setKeyFieldCheck(index)
                                  }
                                />
                              </div>
                            </Card>
                          </div>
                        </div>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
};

export default AddHierarchy;
